import { useState } from 'react';

import LoadIndicator from './Loader';
import { Button, ButtonProps } from './ui/button';

interface ButtonWithLoaderProps extends ButtonProps
{
	loading?: boolean;
}

const ButtonWithLoader = ({ children, loading, onClick, ...props }: ButtonWithLoaderProps) =>
{
	const [isLoading, setIsLoading] = useState(loading);

	const showLoader = loading !== undefined ? loading : isLoading;

	return (
		<Button
			disabled={showLoader}
			onClick={(e: any) =>
			{
				setIsLoading(true);
				onClick?.(e);
			}}
			{...props}
		>
			{children}
			{showLoader && <LoadIndicator className={props.variant === 'primary' ? 'text-white' : ''} />}
		</Button>
	);
};

export default ButtonWithLoader;
